module.exports = __webpack_public_path__ + "img/icon-MA-Welcome.1477694a.png";